import { ReactElement } from "react";
import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

const AlertBell = ({
  height = "24px",
  width = "24px"
}: IconProps): ReactElement => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11908_3647)" id="Alert Icon">
        <path
          d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z"
          fill="#040404"
          id="Vector"
        />
        <path
          clipRule="evenodd"
          d="M5.14286 6.38596C5.14286 4.96012 6.4318 4 8 4C8.94487 4 9.67253 4.22565 10.1659 4.67308C10.6643 5.12521 10.8571 5.7431 10.8571 6.38596V7.95836L11.9435 9.82619C12.0193 9.9565 12.0188 10.1166 11.9421 10.2464C11.8654 10.3762 11.7242 10.4561 11.5714 10.4561H9.70939C9.67617 10.9269 9.47573 11.3097 9.16866 11.5779C8.8395 11.8653 8.41274 12 8 12C7.58726 12 7.1605 11.8653 6.83134 11.5779C6.52427 11.3097 6.32383 10.9269 6.29061 10.4561H4.42857C4.2758 10.4561 4.13458 10.3762 4.0579 10.2464C3.98121 10.1166 3.98067 9.9565 4.05647 9.82619L5.14286 7.95836V6.38596ZM7.15135 10.4561C7.18014 10.685 7.27913 10.8422 7.4008 10.9485C7.55379 11.0821 7.76989 11.1579 8 11.1579C8.23011 11.1579 8.44621 11.0821 8.5992 10.9485C8.72087 10.8422 8.81986 10.685 8.84866 10.4561H7.15135ZM8 4.84211C6.74763 4.84211 6 5.5662 6 6.38596V8.07018C6 8.14345 5.98054 8.21546 5.94353 8.27908L5.16708 9.61404H10.8329L10.0565 8.27908C10.0195 8.21546 10 8.14345 10 8.07018V6.38596C10 5.90602 9.85966 5.54146 9.58443 5.29183C9.30404 5.03751 8.81741 4.84211 8 4.84211Z"
          fill="white"
          fillRule="evenodd"
          id="Vector (Stroke)"
        />
      </g>
      <defs>
        <clipPath id="clip0_11908_3647">
          <rect fill="white" height={height} width={width} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertBell;
